/*
 * @Author: HB-BruceWang
 * @Date: 2025-02-12 18:03:01
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-02-26 17:46:50
 * @FilePath: \shopify-web\src\pages\paid-extended-warranty\snippets\form\index.js
 * @Description:付费延保表单
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */

import JustValidate from 'just-validate';
import { getPEWServiceInfo, checkPEWProject } from "@utils/api.js";
import { renderPEWSelect } from './js/pew-select';
import { initPEWTooltip } from './js/pew-tooltip';
import { initPartTwo } from './js/part-two';
let pewIdSelectInstance;
let pewServiceSelectInstance;

export function PEWForm(isEditMode) {
  // 付费延保服务接口信息
  let pewServiceInfo = undefined;
  let validateFormOne = undefined;
  const $pewForm = $('.pew-form');
  const $pewID = $('#pew_id');
  const $pewServiceWrapper = $('#pew_service_wrapper');
  const $pewService = $('#pew_service');
  const $btnNext = $('#pewFormOne .btn-next');

  // 表单校验提示语
  const ValidateMessages = {
    required: $pewForm.data('required-tips') || 'This field is required',
    orderSNFormatCheck: $pewForm.data('order-sn-format-check-tips') || 'The format is incorrect,please re-enter it.',
    minFilesCount: $pewForm.data('min-files-count-tips') || 'Files count should be more or equal than 1',
    imgFormatCheck: $pewForm.data('img-format-check-tips') || 'Only JPG, PNG, or JPEG file formats are supported. Please ensure the format is correct.',
    imgUploading: $pewForm.data('img-uploading-tips') || 'Image is being uploaded, please wait...',
    maxSize: $pewForm.data('max-size-tips') || 'The total upload size should not exceed 10MB. Please check the file size before re-uploading.',
    pageUnloadTips: $pewForm.data('page-unload-tips') || 'Closing or refreshing the page will lose data, do you want to continue?'
  }

  // 版块一表单校验初始化
  const initValidateFormOne = () => {
    validateFormOne = new JustValidate('#pewFormOne');
    validateFormOne
      .addField('#pew_id', [
        {
          rule: 'required',
          errorMessage: ValidateMessages.required
        },
      ], {
        errorsContainer: document.querySelector('[data-field="pew_id"]'),
      })
      .addField('#pew_service', [
        {
          rule: 'required',
          errorMessage: ValidateMessages.required
        },
      ], {
        errorsContainer: document.querySelector('[data-field="pew_service"]'),
      })
  }

  /**
   * 付费延保服务订单ID列表渲染
   * @param {*} pewServiceInfo
   */
  const renderServiceID = (pewServiceInfo) => {
    let dataList = [];
    pewServiceInfo.forEach(order => {
      dataList.push({
        label: order.orderSn,
        value: order.oid,
        type: order.warrantyProjectList[0].warrantyProjectId
      })
    });
    // 销毁旧实例
    if (pewIdSelectInstance) {
      pewIdSelectInstance.destroy();
    }
    // 创建新实例
    pewIdSelectInstance = new renderPEWSelect('pew_id', dataList);
  }

  /**
   * 延保服务列表初始化
   * @param {*} dataList
   */
  const initServiceList = (dataList) => {
    // 销毁旧实例
    if (pewServiceSelectInstance) {
      pewServiceSelectInstance.destroy();
    }
    // 创建新实例
    pewServiceSelectInstance = new renderPEWSelect('pew_service', dataList);
  }

  /**
   * 延保服务列表渲染
   * @param {*} selectedServiceId 所选服务订单ID
   */
  const renderServiceList = (selectedServiceId) => {
    const order = pewServiceInfo.find(order => order.oid === selectedServiceId);
    let dataList = [];
    if (!order) {
      $pewServiceWrapper.attr('disabled', true);
      initServiceList(dataList);
    } else {
      $pewServiceWrapper.attr('disabled', false);
      order.warrantyProjectList.forEach(project => {
        dataList.push({
          label: project.warrantyProjectName,
          value: project.warrantyProjectId,
          type: project.warrantyProductName || "No product"
        });
      });

      initServiceList(dataList);

      // 只有一个延保项目自动选中
      if (order.warrantyProjectList.length === 1) {
        $pewServiceWrapper.find('.select-items li:first-child').trigger('click');
      }
    }
  }

  /**
   * 无数据提示
   */
  const noDataHandle = (msg) => {
    $('#pew_id_wrapper, #pew_service_wrapper, #pewFormOne .btn-next').attr('disabled', true);
    validateFormOne.showErrors({ '#pew_id': msg })
  }

  // 表单一提交
  const submitFormOne = async () => {
    const warrantyProjectId = $('#pew_service').val();
    let flagInfo;
    try {
      flagInfo = await checkPEWProject({ warrantyProjectId })
    } catch (error) {
      // 不可继续延保
      validateFormOne.showErrors({ '#pew_service': error.message })
    }
    if (flagInfo.success) {
      // 可以继续执行延保，显示版块二表单
      $('.pew-form .part-one').hide().siblings('.part-two').show();

      const backStatus = $('.pew-form').attr('data-back-status');
      if (backStatus === 'false') {
        initPartTwo(ValidateMessages, isEditMode);
      }
    }
  }

  // 表单展示
  const showForm = async () => {
    try {
      const info = await getPEWServiceInfo();
      if (info.success) {
        // 有数据执行渲染
        pewServiceInfo = info.data;
        renderServiceID(info.data);
      } else {
        noDataHandle(info.message);
      }
    } catch (error) {
      noDataHandle(error.message);
    }
  }

  // 表单事件绑定
  const handleEvent = () => {
    // 重置表单，重新获取数据
    $('#pewFormTwo .btn-submit').on('resetEvent', function () {
      showForm();
    });

    // 监听订单ID选择
    $pewID.on('customValChange', function (e) {
      const selectedServiceId = $(this).val();
      renderServiceList(parseInt(selectedServiceId));
      // 校验表单
      validateFormOne.revalidateField('#pew_id').then(isValid => {
        if (isValid) {
          // 验证通过后 切换状态
          $pewServiceWrapper.attr('disabled', false);
        } else {
          $pewServiceWrapper.attr('disabled', true);
        }
      });
      validateFormOne.revalidate().then(isValid => {
        if (isValid) {
          $btnNext.attr('disabled', false);
        } else {
          $btnNext.attr('disabled', true);
        }
      });
    })

    // 监听延保服务选择
    $pewService.on('customValChange', function (e) {
      validateFormOne.revalidate().then(isValid => {
        if (isValid) {
          $btnNext.attr('disabled', false);
        } else {
          $btnNext.attr('disabled', true);
        }
      });
    })

    // 下一步
    $btnNext.off('click').click(function () {
      validateFormOne.revalidate().then(isValid => {
        if (isValid) {
          // 验证通过后提交表单
          $(this).attr('disabled', true);
          submitFormOne();
        }
      });
    })

    // 监听浏览器的关闭或刷新事件
    window.addEventListener('beforeunload', (event) => {
      // 阻止默认行为
      event.preventDefault();
      // 设置返回值，浏览器会自动将返回值作为提示信息（注：常见浏览器不会使用下列文案，而是使用本身自带文案）
      return ValidateMessages.pageUnloadTips;
    });
  }

  // 初始化
  const init = async () => {

    initValidateFormOne();
    initPEWTooltip();

    if (isEditMode) {
      // 编辑模式适配，方便查看版块二配置情况
      $('.pew-form .part-two').show();
      initPartTwo(ValidateMessages, isEditMode);
      return;
    }

    showForm();
    handleEvent();
  }

  init();

}